import React, { useState } from 'react';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import LightButton from '../button/LightButton';
import ConfirmModal from '../modal/ConfirmModal';

const ExtendedFunctionalTableComponent = ({
  shortVersionColumns,
  ...props
}) => {
  const [showExtended, setShowExtended] = useState(false);

  return (
    <>
      <FunctionalTableComponent
        shadow={false}
        title={props.title}
        withoutCreate={true}
        columns={shortVersionColumns}
        header={true}
        api={props.api}
        removable={false}
        editable={false}
        width={12}
        toolBarButton={
          <>
            <div className={'d-flex gap-2'}>
              <LightButton onClick={() => setShowExtended(true)}>
                Widok rozszerzony
              </LightButton>
              {props.toolBarButton}

            </div>
          </>
        }
      />
      <ConfirmModal
        buttonsConf={{ save: 'Zamknij' }}
        fullscreen={true}
        show={showExtended}
        setShow={setShowExtended}
      >
        <FunctionalTableComponent {...props} />
      </ConfirmModal>
    </>
  );
};

export default ExtendedFunctionalTableComponent;
